module.exports = __webpack_public_path__ + "static/onmymind_bannerM@2x-b4979e033d6eb3792c8405d0735ee3ef.png";